import { ApiClient } from '../ApiClient';
import events from '../events';
const apiClient = new ApiClient('/api/subscriptions');
export function subscribeModule({ sku, title, subscription }) {
    var _a, _b, _c;
    let customerSubscriptionId = (_a = subscription === null || subscription === void 0 ? void 0 : subscription.id) !== null && _a !== void 0 ? _a : 0;
    return {
        title,
        isBusy: false,
        isSubscribed: !!subscription,
        quantity: (_b = subscription === null || subscription === void 0 ? void 0 : subscription.quantity) !== null && _b !== void 0 ? _b : 1,
        status: (_c = subscription === null || subscription === void 0 ? void 0 : subscription.status) !== null && _c !== void 0 ? _c : 1,
        error: [],
        showPopup: false,
        isChecked: false,
        onUpdate(newQuantity) {
            this.quantity = newQuantity;
        },
        openPopup() {
            this.isChecked = false;
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;
        },
        async subscribe() {
            var _a;
            this.showPopup = false;
            this.isBusy = true;
            try {
                var result = await apiClient.post('/subscribe', {
                    sku,
                    quantity: this.quantity
                });
                this.isSubscribed = true;
                this.status = result.status;
                customerSubscriptionId = result.id;
                (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'newsletter');
            }
            catch (err) {
                if (err.status === 401) {
                    events.openLogin.trigger({ open: true, centeredFixed: true });
                }
                this.error.push(err);
            }
            finally {
                this.isBusy = false;
            }
        },
        async unsubscribe() {
            this.isBusy = true;
            try {
                await apiClient.post('/unsubscribe', {
                    customerSubscriptionId
                });
                this.isSubscribed = false;
                this.status = 1;
            }
            catch (err) {
                if (err.status === 401) {
                    events.openLogin.trigger({ open: true, centeredFixed: true });
                }
                this.error.push(err);
            }
            finally {
                this.isBusy = false;
            }
        }
    };
}
